export default "__VITE_ASSET__5d289ea5__"